export default __webpack_public_path__ + "static/media/cup.254dac04.svg";